import type { InsuranceType } from 'services/types/sale';

export interface SaleCreatePrefill {
  clientId: number;
  insuranceType: InsuranceType;
  institutionName: string;
  totalAskedAmount: string;
  pendingBalance: string;
  remainingQuotas: string;
  installmentValue: string;
  simulationResult: number | null;
}

type Listener = (prefill: SaleCreatePrefill) => void;

const listeners = new Set<Listener>();

export const emitSaleCreatePrefill = (prefill: SaleCreatePrefill): void => {
  listeners.forEach((listener) => listener(prefill));
};

export const subscribeToSaleCreatePrefill = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
